import React, { useState } from 'react';

function FAQItem({ question, answer }) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="mb-4">
            <div
                className="flex justify-between items-center cursor-pointer p-2 border-b"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className='text-slate-800 font-semibold'>{question}</span>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>
            {isOpen && <p className="mt-2 ml-4 font-inter text-md text-slate-800">{answer}</p>}
        </div>
    );
}

export default function FAQ() {
    const faqs = [
        {
            question: 'What is the Background Color Changer tool?',
            answer:
                "It's an online tool designed to swiftly change the background color of any image. It’s perfect for adapting photos to match specific themes, moods, or branding guidelines without the need for complex software."
        },
        {
            question: 'Do I need to download or install anything?',
            answer:
                'No! Our tool is entirely web-based, meaning you can change background colors directly from your browser without any downloads or installations.'
        },
        {
            question: 'How does the Background Color Changer work?',
            answer:
                'Our tool uses advanced algorithms to identify and replace the original background color of your image. Simply upload your image, select your desired background color, and let the tool handle the rest!'
        },
        {
            question: 'Is my image data secure?',
            answer:
                'Absolutely! Your image is processed on the fly and is never stored on our servers. We value your privacy and have implemented measures to ensure the security and confidentiality of your data.'
        },
        {
            question: 'Can I use the tool on mobile devices?',
            answer:
                'Yes, the Background Color Changer is designed to be responsive and can be used on both desktops and mobile devices for on-the-go modifications.'
        }
    ];

    return (
        <div className='w-full flex justify-center items-center'>
            <div className="w-full md:w-1/2">
                <h2 className='text-center font-inter text-2xl font-bold text-slate-800 my-6'>Frequently Asked Questions</h2>
                {faqs.map((faq, index) => (
                    <FAQItem key={index} {...faq} />
                ))}
            </div>
        </div>
    );
}
